// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"43620505","455":"cd96b077","977":"05490948"}[chunkId] + ".chunk.js";
};